import type { ColumnDefinition } from "@frui.ts/dataviews";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import type CreditExposure from "entities/creditExposure";
import { formatDate, formatNumber } from "utils/localizations";
import CreditExposuresViewModel from "viewModels/timeCharges/distributors/creditExposures/creditExposuresViewModel";
import ListView from "../../../common/list";
import HeaderRow from "@edaz/edazkit/HeaderRow/index";
import CreditExposuresFilter from "./creditExposuresFilter";
import CreditExposureCards from "./creditExposureCards";

const CreditExposuresView: ViewComponent<CreditExposuresViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<CreditExposure>[] = [
    {
      title: vm.translateAttribute("state"),
      property: "state",
      valueFormatter: props => vm.translateCreditExposureState(props.item.state),
    },
    {
      title: vm.translateAttribute("validSinceDate"),
      property: "validSinceDate",
      valueFormatter: props => formatDate(props.value),
    },
    {
      title: vm.translateAttribute("validUntilDate"),
      property: "validUntilDate",
      valueFormatter: props => formatDate(props.value),
    },
    {
      title: vm.translateAttribute("type"),
      property: "type",
      valueFormatter: props => vm.translateCreditExposureType(props.item.type),
    },
    {
      title: vm.translateAttribute("description"),
      property: "description",
    },
    {
      title: vm.translateAttribute("amount"),
      property: "amount",
      valueFormatter: props => `${formatNumber(props.value)} ${vm.translateGeneral("czk")}`,
    },
  ];

  return (
    <>
      <HeaderRow level={3} title={vm.translate("name")} className="mb-4" />
      <CreditExposuresFilter vm={vm} />
      <CreditExposureCards vm={vm} />
      {vm.selectedDistributorId && vm.currentCreditExposure && (
        <ListView showDetailWithList={true} vm={vm} columns={columns} title={vm.translate("title")} />
      )}
    </>
  );
});

registerView(CreditExposuresView, CreditExposuresViewModel);
